import { Badge } from "@thilke/ui/components/badge";
import { Button } from "@thilke/ui/components/button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@thilke/ui/components/select";
import { Separator } from "@thilke/ui/components/separator";
import { BookOpen, Package } from "lucide-react";
import { type RegistryTheme, registryThemes } from "../theme-options";

type AppContentHeaderProps = {
  origin: string;
  itemCount: number;
  visibleCount: number;
  theme: RegistryTheme;
  onThemeChange: (theme: RegistryTheme) => void;
};
export function AppContentHeader({
  origin,
  itemCount,
  visibleCount,
  theme,
  onThemeChange,
}: AppContentHeaderProps) {
  return (
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-2 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/80 lg:px-6">
      <BookOpen className="size-4" />
      <h1 className="text-sm font-medium">Thilke UI Registry</h1>
      <Separator orientation="vertical" className="mx-2 h-4" />
      <Badge variant="outline">
        {visibleCount}/{itemCount} items
      </Badge>
      <div className="ml-auto flex items-center gap-2">
        <Select
          value={theme}
          onValueChange={(value) => onThemeChange(value as RegistryTheme)}
        >
          <SelectTrigger size="sm" className="hidden w-40 sm:flex">
            <SelectValue aria-label="Registry theme" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {registryThemes.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
        <Button
          variant="ghost"
          asChild
          size="sm"
          className="hidden sm:inline-flex"
        >
          <a href={`${origin}/registry.json`} target="_blank" rel="noreferrer">
            <Package className="size-4" /> registry.json
          </a>
        </Button>
      </div>
    </header>
  );
}
